/**
 * Returns `true` if Gtag Client Side is enabled
 */
const isGtagClientSideEnabledInEnv = (): boolean => __GTAG_CLIENT_SIDE_ENABLED__ === 'true';

export default isGtagClientSideEnabledInEnv;
